import React, { useState } from 'react';

const SearchPanel = ({ onSearch, results, sources, onAddToNetwork }) => {
  const [query, setQuery] = useState('');
  const [searching, setSearching] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSearching(true);
    await onSearch(query);
    setSearching(false);
  };

  const sourceById = new Map(sources.map((source) => [source._id, source]));

  return (
    <div className="search-panel">
      <header>
        <h2>Family Finder Search</h2>
        <p className="search-panel__hint">Pull in new kin from curated open-data sources.</p>
      </header>
      <form onSubmit={handleSubmit} className="search-panel__form">
        <input
          type="search"
          placeholder="Search by name, city, or relationship"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
        <button type="submit" className="primary" disabled={searching || !query.trim()}>
          {searching ? 'Searching…' : 'Search'}
        </button>
      </form>
      <div className="search-panel__sources">
        <h3>Available Sources</h3>
        <ul>
          {sources.map((source) => (
            <li key={source._id}>
              <strong>{source.name}</strong>
              <span className="chip chip--muted">{source.type}</span>
              {source.enabled ? <span className="badge badge--success">enabled</span> : <span className="badge">disabled</span>}
            </li>
          ))}
        </ul>
      </div>
      <ul className="search-panel__results">
        {results.map((result) => {
          const source = sourceById.get(result.source);
          return (
            <li key={result._id}>
              <header>
                <div>
                  <strong>{result.name}</strong>
                  <span className="chip chip--muted">{result.relationshipHint}</span>
                </div>
                <span className="badge badge--info">{Math.round(result.confidence * 100)}% match</span>
              </header>
              <p>
                {result.city}, {result.state}
              </p>
              <p className="search-panel__provenance">
                Source: {source?.name ?? result.source} • Provenance: {(result.provenance || []).join(', ')}
              </p>
              <div className="search-panel__actions">
                <button
                  type="button"
                  disabled={result.alreadyConnected}
                  onClick={() => onAddToNetwork(result)}
                >
                  {result.alreadyConnected ? 'Already in network' : 'Add to network'}
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SearchPanel;
